import {
  parsePhoneNumberFromString,
  getCountries,
  getCountryCallingCode,
  getExampleNumber,
} from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';

const nombres = new Intl.DisplayNames(['es'], { type: 'region' });
const bandera = (iso) =>
  iso.replace(/./g, (c) => String.fromCodePoint(127397 +
c.charCodeAt(0)));
const soloDigitos = (txt) => (txt || '').replace(/\D/g, '');

// Países que salen primero en la lista
const PRIMEROS = ['MX', 'US'];

export const PAISES = getCountries()
  .map((iso) => ({
    iso,
    bandera: bandera(iso),
    lada: `+${getCountryCallingCode(iso)}`,
    nombre: nombres.of(iso),
  }))
  .sort((a, b) => {
    const pa = PRIMEROS.indexOf(a.iso);
    const pb = PRIMEROS.indexOf(b.iso);
    if (pa !== -1 || pb !== -1) return (pa === -1 ? 99 : pa) - (pb ===
-1 ? 99 : pb);
    return a.nombre.localeCompare(b.nombre, 'es');
  });


export const ejemploNacional = (iso) => {
  const ej = getExampleNumber(iso, examples);
  return ej ? soloDigitos(ej.formatNational()) : '';
};

// Valida el número para el país. Devuelve null si no es válido.
export const validarCelular = (numero, iso) => {
  const p = parsePhoneNumberFromString(soloDigitos(numero), iso);
  if (!p || !p.isValid()) return null;
  return { e164: p.number, nacional: soloDigitos(p.formatNational()) };
};

// Separa un celular guardado (+593989...) en país y número nacional
export const separarCelular = (celular) => {
  const p = parsePhoneNumberFromString((celular || '').trim());
  if (!p) return { iso: 'MX', nacional: '' };
  return { iso: p.country || 'MX', nacional: soloDigitos(p.formatNational()) };
};

